import '.bl{font-size:1.125rem;}.ssr-plugin'
import '.gg{line-height:1.75rem;}.ssr-plugin'
import '.b7{text-decoration:none;}.ssr-plugin'
import '.e9{color:var(--brand-primary);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="bl gg"
    >
      {translations.privacySubtitle}{' '}
      <a className="b7 e9"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="b7 e9"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
